// store/global/atoms.ts
import { CreateLuraSignUserParams } from '../../../../services/user/create-lura-sign-user.service';
import { QUERY_KEYS } from '../../../../consts';
import { createLuraSignUserService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const createLuraSignUserAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER.CREATE_LURA_SIGN_USER,
  mutationFn: () => (params: CreateLuraSignUserParams) => createLuraSignUserService(params),
  retry: 0,
});